<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation (drawer on phones and tablets) -->
@if (isScreenSmall) {
    <fuse-vertical-navigation
        class="dark bg-gray-900 print:hidden"
        [mode]="'over'"
        [name]="'mainNavigation'"
        [navigation]="navigation.default"
        [opened]="false"
    >
        <!-- Navigation header hook -->
        <ng-container fuseVerticalNavigationContentHeader>
            <div class="flex items-center justify-between px-6 pb-2 pt-6">
                <div class="flex items-center rounded-xl bg-white px-3 py-2">
                    <img class="w-24" src="images/logo/logo.png" alt="Wilderness India" />
                </div>
                <button
                    mat-icon-button
                    aria-label="Close menu"
                    (click)="toggleNavigation('mainNavigation')"
                >
                    <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                </button>
            </div>
        </ng-container>
    </fuse-vertical-navigation>
}

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
    <!-- Header -->
    <header
        class="wi-header relative z-49 flex h-16 w-full flex-0 items-center gap-2 border-b bg-primary/10 px-3 dark:bg-transparent sm:h-18 sm:px-4 lg:h-20 lg:px-6 print:hidden"
    >
        <!-- Menu button (phones and tablets) -->
        @if (isScreenSmall) {
            <button
                mat-icon-button
                aria-label="Open menu"
                (click)="toggleNavigation('mainNavigation')"
            >
                <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
            </button>
        }

        <!-- Logo -->
        <a
            class="flex shrink-0 items-center"
            [class.wi-header-logo-divider]="!isScreenSmall"
            routerLink="/dashboard"
            aria-label="Go to dashboard"
        >
            <img
                class="h-10 w-auto sm:h-12 lg:h-14"
                src="images/logo/logo.png"
                alt="Wilderness India"
            />
        </a>

        <!-- Horizontal navigation (laptops and desktops) -->
        @if (!isScreenSmall) {
            <fuse-horizontal-navigation
                class="wi-horizontal-nav min-w-0"
                [name]="'mainNavigation'"
                [navigation]="navigation.horizontal"
            ></fuse-horizontal-navigation>
        }

        <!-- Components -->
        <div class="ml-auto flex shrink-0 items-center gap-0.5 sm:gap-1">
            <fuse-fullscreen class="hidden xl:block"></fuse-fullscreen>
            <notifications></notifications>
            <button
                mat-icon-button
                aria-label="Quick chat"
                (click)="quickChat.toggle()"
            >
                @if ((quickChat.totalUnread$ | async) > 0) {
                    <span
                        class="absolute left-0 right-0 top-0 flex h-3 items-center justify-center"
                    >
                        <span
                            class="ml-4 mt-2.5 flex h-4 min-w-4 shrink-0 items-center justify-center rounded-full bg-teal-600 px-1 text-xs font-medium text-indigo-50"
                        >
                            {{ quickChat.totalUnread$ | async }}
                        </span>
                    </span>
                }
                <mat-icon
                    [svgIcon]="'heroicons_outline:chat-bubble-left-right'"
                ></mat-icon>
            </button>
            <span class="mx-1 hidden h-8 w-px bg-primary/20 sm:block"></span>
            <user></user>
        </div>
    </header>

    <!-- Content -->
    <div class="flex w-full flex-auto flex-col">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
</div>

<!-- Quick chat -->
<quick-chat #quickChat="quickChat"></quick-chat>
